import axios from "axios";

import { Message } from "element-ui";
import constant from "@/common/constant";
import AccessUtil from "@/common/AccessUtil";

const CancelToken = axios.CancelToken;
let source = CancelToken.source();
axios.defaults.withCredentials = true;
let service = axios.create({
  // baseURL: 'http://172.16.20.59:7660',
  // baseURL: 'http://172.16.20.62:7660',e
  // baseURL: '172.16.20.96:7660'
  // baseURL: `${location.protocol}//${process.env.VUE_APP_BASE_API}`
  // baseURL: `http://172.16.20.196:7660`,
  baseURL:
    process.env.NODE_ENV == "development" || process.env.NODE_ENV == "test"
      ? `https://${process.env.VUE_APP_BASE_API}`
      : `https://${process.env.VUE_APP_BASE_API_pro}`,
  timeout: 1500000,
});

let loadingContainer = null;
let needLoadingRequestCount = 0;

/**
 * @function showFullScreenLoading
 * @description 显示全屏加载动画
 * @param {boolean} show 是否显示
 */
function startLoading() {
  let barElement1 = document.createElement("div");
  barElement1.setAttribute("class", "bar");

  let barElement2 = document.createElement("div");
  barElement2.setAttribute("class", "bar");

  let barElement3 = document.createElement("div");
  barElement3.setAttribute("class", "bar");

  let loadingElement = document.createElement("div");
  loadingElement.setAttribute("class", "loading");
  loadingElement.appendChild(barElement1);
  loadingElement.appendChild(barElement2);
  loadingElement.appendChild(barElement3);

  loadingContainer = document.createElement("div");
  loadingContainer.setAttribute("class", "loading-container");
  loadingContainer.appendChild(loadingElement);

  document.body.appendChild(loadingContainer);
}

function closeLoading() {
  document.body.removeChild(loadingContainer);

  loadingContainer = null;
}

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }

  needLoadingRequestCount++;
}

/**
 * @function hideFullScreenLoading
 * @description 隐藏全屏加载动画
 */
function hideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    return;
  }

  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    closeLoading();
  }
}

service.interceptors.request.use(
  function (config) {
    showFullScreenLoading();

    if (AccessUtil.getAuthToken() != null) {
      config.headers["X-Auth-Token"] = AccessUtil.getAuthToken();
    }

    config.headers["X-App-Key"] = process.env.VUE_APP_APP_KEY;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  function (response) {
    hideFullScreenLoading();

    if (!response.data) {
      return Promise.reject("Null response");
    }

    if (response.data.code === constant.RESPONSE_CODE_LIST.SUCCESS) {
      return response.data;
    } else if (
      response.data.code === constant.RESPONSE_CODE_LIST.TOKEN_INVALID
    ) {
      Message({
        message: response.data.message,
        type: "error",
        duration: 5 * 1000,
      });

      let baseUrl = process.env.VUE_APP_BASE_URL;
      let reg = new RegExp("\/$"); // eslint-disable-line
      if (reg.test(process.env.VUE_APP_BASE_URL)) {
        baseUrl = process.env.VUE_APP_BASE_URL.substring(
          0,
          process.env.VUE_APP_BASE_URL.length - 1,
        );
      }

      // location.href = baseUrl + "/login";
    } else if (
      response.data.code !== constant.RESPONSE_CODE_LIST.SUCCESS &&
      response.data.code !== constant.RESPONSE_CODE_LIST.TOKEN_INVALID
    ) {
      Message({
        message: response.data.message,
        type: "error",
        duration: 5 * 1000,
      });

      return response.data;
    } else {
      return Promise.reject("未知错误");
    }
  },
  function (error) {
    hideFullScreenLoading();

    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });

    return Promise.reject(error);
  },
);

export default {
  get(url, param) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        params: param,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post3(url, param, data) {
    return new Promise((resolve, reject) => {
      // data = Qs.stringify(data);
      service({
        headers: {
          "Content-Type": "application/json",
        },
        method: "post",
        url,
        params: param,
        data: JSON.stringify(data),
        // cancelToken: source.token
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  post5(url, data) {
    return new Promise((resolve, reject) => {
      service({
        headers: {
          "Content-Type": "application/json",
        },
        method: "post",
        url,
        data,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  put(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "put",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "delete",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downLoad(url, data) {
    return new Promise(() => {
      service({
        method: "get",
        url: url,
        data: data,
        responseType: "blob",
      })
        .then((response) => {
          this.download(response);
        })
        .catch((error) => {});
    });
  },
};
